import React, { Component } from "react";
import "./Contact.css"

class Contact extends Component {
    render(){
        return(
            <>
            <div className="contact">
                <div className="contact-block">
                    <h1 className="font-text">
                        Contact Us
                    </h1>
                    <p className="font-text contact-intro">
                        Have questions about our services or want to see how we can help your group? Reach out—we’d love to connect!
                    </p>
                    <div className="contact-info">
                        <p><strong>Email:</strong> improvingthefuture1@gmail.com</p>
                        <p><strong>Phone:</strong> (678) 242-9496</p>
                    </div>
                    <a href="mailto:improvingthefuture1@gmail.com" className="btn primary-btn">Send Email</a>
                </div>
            </div>
            </>
        );
    }
}
export default Contact;